import { render, staticRenderFns } from "./OrganizationBankAccountSelector.vue?vue&type=template&id=6a09a143"
import script from "./OrganizationBankAccountSelector.vue?vue&type=script&lang=js"
export * from "./OrganizationBankAccountSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports